"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var numberMeasure_1 = require("../measure/numberMeasure");
var base_1 = require("./base");
var common_1 = require("./common");
var metric_1 = require("./metric");
// Mass
exports.carats = numberMeasure_1.Measure.of(200, metric_1.milli(common_1.grams), "ct");
// Length
exports.angstroms = numberMeasure_1.Measure.of(0.1, metric_1.nano(base_1.meters), "Å");
// Area
exports.ares = numberMeasure_1.Measure.of(100, base_1.meters.squared(), "a");
exports.hectares = numberMeasure_1.Measure.of(10000, base_1.meters.squared(), "ha");
// Volume
exports.liters = numberMeasure_1.Measure.of(0.001, base_1.meters.cubed(), "L");
// Velocity
exports.speedOfLight = numberMeasure_1.Measure.of(299792458, base_1.meters.per(base_1.seconds), "C");
// Pressure
exports.bars = numberMeasure_1.Measure.of(100000, metric_1.pascals, "bar");
exports.atmospheres = numberMeasure_1.Measure.of(101325, metric_1.pascals, "atm");
exports.torrs = numberMeasure_1.Measure.of(1 / 760, exports.atmospheres, "Torr");
//# sourceMappingURL=other.js.map